import React from "react";
import AppButton from "../../element/button/AppButton";
import BasicModal, {IBasicModalProps} from "./BasicModal";

export interface IChooseTextOptionModalProps extends IBasicModalProps {
    textOptions: string[]
}

export default class ChooseTextOptionModal extends BasicModal
{
    props: IChooseTextOptionModalProps;

    constructor(props: IChooseTextOptionModalProps)
    {
        super(props);

        this.props = props;
    }

    renderFooterRight(): React.JSX.Element
    {
        return this.cancelFooterButtons();
    }

    renderBody(): React.JSX.Element
    {

        return <>
            <div className="container">
                <div className="row">
                    <div className="col-12">

                        <table className="table-shrink w-100">
                            <tbody>
                            {this.props.textOptions.map((textOption, index) =>
                            {
                                return <tr key={index}>
                                    <td className="primary-column">
                                        {textOption}
                                    </td>
                                    <td>
                                        <AppButton className="btn" onClick={() => this.handleAccept(index)}>Select</AppButton>
                                    </td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    }
}